import axios, { AxiosResponse } from "axios";
import { ApiResourceResponseInterface, LaravelPaginate } from "../types/LaravelCommonTypes";
import ActivityLogResource from "@customTypes/resources/ActivityLogResource";

export interface ListActivityLogsRequestParameters {
    subject_type: string;
    subject_uuid: string;
    page?: number;
    amount?: number;
    order_by?: string,
    order_direction?: 'asc' | 'desc',
    date_from?: string | null,
    date_to?: string | null,
    query?: string | null,
}

export default class ActivityLog {
    static index(parameters: ListActivityLogsRequestParameters) {
        return axios.get<ApiResourceResponseInterface<ActivityLogResource[]>>(
            route("api.activity-logs.index", parameters)
        );
    }
}
